<template>
    <div v-if="liveChat">
        <LiveChatWidget :customer-name="username" :customer-email="useremail" :license="license" :visibility="visibility" @new-event="handleChatWidgetEvent" />
    </div>
</template>

<script>
import { LiveChatWidget } from '@livechat/widget-vue';
import { mapGetters } from 'vuex';
import { useCcm19Global } from '../../useCcm19Global';

export default {
    components: {
        LiveChatWidget
    },
    setup() {
        const { onReady, liveChat } = useCcm19Global();
        onReady(() => {});

        return { liveChat };
    },
    data() {
        return {
            license: '15527991',
            visibility: 'minimized',
            routesToHideChatWidget: ['/dashboard', '/hkcmnews', '/videos']
        };
    },
    computed: {
        ...mapGetters('user', {
            username: 'getName',
            useremail: 'getEmail'
        })
    },
    mounted() {
        this.$router.afterEach((to) => {
            this.checkWidgetHideCondition(to.path);
        });
    },

    methods: {
        handleChatWidgetEvent(event) {
            switch (event.type) {
                case 'message':
                case 'rich_message':
                    this.visibility = 'minimized';
                    break;
                default:
                    break;
            }
            this.checkWidgetHideCondition(this.$route.fullPath);
        },
        checkWidgetHideCondition(fullPath) {
            // Desktop
            if (window.innerWidth > 1024) {
                return;
            }

            // Mobile
            for (const route of this.routesToHideChatWidget) {
                if (fullPath.startsWith(route)) {
                    this.visibility = 'hidden';

                    return;
                }
            }

            this.visibility = 'minimized';
        }
    }
};
</script>
